import React  from 'react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { grey } from '@mui/material/colors'
import { useTheme } from '@emotion/react';
import { useRecoilValue } from 'recoil';
import StepperCustom from 'src/shared/components/steps/StepperCustom';
import { activeStepRegisterState, completedStepRegisterState } from 'src/Patient/state/atoms';

const steps = ['Completar datos', 'Crear clave', 'Confirme cuenta'];
const StepsRegister = ({ color = "white" }) => {
  const theme = useTheme();
  const activeStepRegister = useRecoilValue(activeStepRegisterState);
  const completedStepRegister = useRecoilValue(completedStepRegisterState);


  return (
    <Box sx={{ padding: 1, maxWidth: 720, margin: '0 auto' }}>
      <StepperCustom color={color} theme={theme} nonLinear activeStep={activeStepRegister}>
        {steps.map((label, index) => (
          <Step key={label} completed={completedStepRegister[index]}>
            <StepButton disableRipple color={grey[400]}>
              {label}
            </StepButton>
          </Step>
        ))}
      </StepperCustom>
    </Box>
  );
}

export default StepsRegister;